import * as Yup from 'yup';

export const formikValidation = {
  email: {
    email: Yup.string().required('Email is required'),
  },

  firstName: {
    firstName: Yup.string().required('First name is required'),
  },
  lastName: {
    lastName: Yup.string().required('Last name is required'),
  },
  artistName: {
    artistName: Yup.string()
      .min(2, 'Artist name must be at least 3 characters')
      .required('Artist name is required'),
  },

  // ------------------------------------------------------------
  // Password Confirmations
  password: {
    password: Yup.string().required('Password is required'),
  },
  currentPassword: {
    currentPassword: Yup.string().required('Current password is required'),
  },
  confirmPassword: {
    confirmPassword: Yup.string()
      .required('Confirm password is required')
      .oneOf([Yup.ref('password')], 'Passwords must match'),
  },
  newPassword: {
    newPassword: Yup.string().required('New password is required'),
  },
  // ------------------------------------------------------------
};
